import React, { useEffect } from 'react';
import { applyFavicon } from 'mini-favicon';
import { getBootstrapOptions } from '../optionsRegistry';
import { getPackageBaseUrl } from 'owa-config';
import { getStore } from 'mini-app-module-store/lib/store/appModuleStore';
import { MiniAppBlockedScreen, shouldBlockApp } from 'mini-app-blocked';
import { Module } from 'mini-common-schema';
import { observer } from 'mobx-react-lite';
import { ThemeProvider } from 'mini-theme/lib/contexts/ThemeContext';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';

function AppModule() {
    const currentModule = getStore().module || Module.Mail;
    const appModuleProps = getBootstrapOptions(currentModule)!.appModuleProps!;

    const isAppBlocked = shouldBlockApp();

    useEffect(() => {
        // update the favicon
        applyFavicon(urlResolve(getPackageBaseUrl(), appModuleProps.overrideFavIcon));
    }, [appModuleProps.overrideFavIcon]);

    return (
        <ThemeProvider>
            {isAppBlocked ? <MiniAppBlockedScreen /> : appModuleProps.renderModule()}
        </ThemeProvider>
    );
}

export default observer(AppModule);
